import { Query } from '@/infrastructure/network/Monitaro/schema/models'

export interface IQueryProps {
  page: number
  take: number
  count?: number
  total?: number
  sort?: string[]
  desc?: (boolean | undefined)[]
  word?: string | null
  query?: any
  extension?: any
  download?: string | null
}

export default class QueryEntity {
  private _props: IQueryProps

  constructor(props?: IQueryProps | null) {
    this._props = EmptyQueryPropsFactory(props)
  }

  get props(): IQueryProps {
    return this._props
  }

  get clone(): IQueryProps {
    return structuredClone(this._props)
  }

  get total(): number | undefined {
    return this._props.total
  }

  get page(): number {
    return this._props.page
  }

  get take(): number {
    return this._props.take
  }

  get count(): number | undefined {
    return this._props.count
  }

  get sort(): string[] | undefined {
    return this._props.sort
  }

  get desc(): (boolean | undefined)[] | undefined {
    return this._props.desc
  }

  get word(): string | null | undefined {
    return this._props.word
  }

  get query(): any | null | undefined {
    return this._props.query
  }

  get extension(): any | null | undefined {
    return this._props.extension
  }
}

export const EmptyQueryPropsFactory = (props?: Partial<IQueryProps> | null): IQueryProps => ({
  page: 0,
  take: 20,
  ...props
})

export const EmptyQueryFactory = (props?: Partial<Query> | null): Query => ({
  page: 0,
  take: 20,
  ...props
})
